/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Choose_TitleInputs */

const en_site_choose_title = /** @type {(inputs: Site_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dissect a website`)
};

const id_site_choose_title = /** @type {(inputs: Site_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedah website`)
};

/**
* | output |
* | --- |
* | "Dissect a website" |
*
* @param {Site_Choose_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_choose_title = /** @type {((inputs?: Site_Choose_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Choose_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_choose_title(inputs)
	return en_site_choose_title(inputs)
});